/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Message_DeleteInputs */

const en_us2_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const pt_br2_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar`)
};

const es_419_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const pt_pt2_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar`)
};

const fr_fr2_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_de2_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const it_it2_clubs_message_delete = /** @type {(inputs: Clubs_Message_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Clubs_Message_DeleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_message_delete = /** @type {((inputs?: Clubs_Message_DeleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Message_DeleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_message_delete(inputs)
	if (locale === "es-419") return es_419_clubs_message_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_message_delete(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_message_delete(inputs)
	if (locale === "de-DE") return de_de2_clubs_message_delete(inputs)
	if (locale === "it-IT") return it_it2_clubs_message_delete(inputs)
	return en_us2_clubs_message_delete(inputs)
});
export { clubs_message_delete as "clubs.message_delete" }